<template>
  <b-container id="maindiv">

    <section>
      <b-row id="content">
        <div class="col-md-9">
          <h2>{{$lang('mail')}}</h2>
          <p>{{$lang('description')}}</p>
        </div>
        <div class="col-md-3">
          <div v-if="loaded" class="toolbar">
            <b-form-select v-if="$store.state.options.mail==1" required v-model="view" :options="views"></b-form-select>
          </div>
        </div>
      </b-row>
    </section>

    <section id="mainsection">

      <b-alert v-if="someskipped" show>{{$lang('someinvisible')}}</b-alert>

      <div id="content">
        <b-table stripped hover head-variant="dark" :items="list" stacked="md" :fields="listFields" :current-page="currentPage" :per-page="perPage" :busy="wait" :tbody-tr-class="rowClass">
          <template slot="s_s" slot-scope="row">
            <a :href="'/#/mail/item?id='+row.item.id">
              <div class="state">
                <i class="fa fa-circle-o mr-1" v-bind:style="{'color': row.item.s_sclr}"></i>{{row.item.s_s}}
              </div>
            </a>
          </template> 
          <template slot="hasattach" slot-scope="row">
            <i v-if="row.item.hasattach > 0" class="fa fa-paperclip"></i>
          </template>  
          <div slot="table-busy" class="text-center text-muted my-5">
             <b-spinner class="align-middle"></b-spinner>
             <strong>{{$lang('loading')}}</strong>
          </div>          
        </b-table>

        <b-row>
          <b-col md="6" class="my-4">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>        

      </div>
    </section>

  </b-container>
</template>

<script>
import axios from 'axios';
export default {
  created() {
    this.wait = true;
    this.fetchList()
  },
  data() {
    return {
      wait: true,
      loaded: false,
      view: 1,
      views: [
        {value: 1, text: this.$lang("inbox")},
        {value: 2, text: this.$lang("sent")},
        {value: 3, text: this.$lang("drafts")},
      ],
      list: [],
      listFields: [
        {key: "s_s", label: this.$lang("state" )},
        {key: "dd", label: this.$lang("date"), sortable: true},
        {key: "adr", label: this.$lang("from")},
        {key: "subj", label: this.$lang("subj")},
        {key: "hasattach", label: ''},
      ],
      totalRows: 30,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15], 
      someskipped: null,           
    };
  },
  watch: {
    view: function () {
      this.$router.replace({name:'mail', query: {view: this.view}});
    },
    $route() {
        this.fetchList();
    },
  },
  methods: {
     fetchList() {
       this.loaded = false;
       if (this.$route.query.view > 0) {
         this.view = this.$route.query.view;
       };
       this.switchAdr();
       axios.get("/api/GetMessagesList?ver=2&view="+this.view)
         .then(resp => {
           this.list = resp.data.messages;
           this.someskipped = resp.data.someskipped;
           this.totalRows = this.list.length;
           this.wait = null;
           this.loaded = true;
         }).catch(err => {
           if (err.response.status == 401)
              this.$router.push('/')
         })
      },
      rowClass(item, type) {
        if (!item || type !== 'row') return
        if (item.notread === 1) return 'table-new'
      },
      switchAdr() {
        if (this.view==2||this.view==3){
          this.listFields[2].label = this.$lang("to") ;
        } else {
          this.listFields[2].label = this.$lang("from") ;
        }
      },
  }, 
  locales: {
    en: {
      mail: "My Messages",
      state: "State",
      date: "Date",
      subj: "Subject",
      from: "From",
      to: "To",
      loading: "Loading...",
      description: " ",
      inbox: "Inbox",
      sent: "Sent",
      drafts: "Drafts",
      someinvisible: "Not all messages are visible in this list due to access policy restrictions."
    },
    de: {
      mail: "Meine Nachrichten",
      state: "Zustand",
      date: "Datum",
      subj: "Betreff",
      from: "Von",
      to: "An",
      loading: "Loading...",
      description: " ",
      inbox: "Posteingang",
      sent: "Gesendete Elemente",
      drafts: "Entwürfe",
      someinvisible: "Aufgrund von Zugriffsrichtlinienbeschränkungen sind in dieser Liste nicht alle Nachrichten sichtbar."      
    },
    ru: {
      mail: "Мои Сообщения",
      state: "Состояние",
      date: "Дата",
      subj: "Тема",
      from: "От",
      to: "Кому",
      loading: "Загрузка...",
      description: " ",
      inbox: "Входящие",
      sent: "Отправленные",
      drafts: "Черновики", 
      someinvisible: "Не все сообщения отображаются в этом списке из-за ограничений политики доступа к информации онлайн."
    },
    pl: {
      mail: "Moje wiadomości",
      state: "Stan",
      date: "Data",
      subj: "Temat",
      from: "Od",
      to: "Do",
      loading: "Ładowanie...",
      description: " ",
      inbox: "Inbox",
      sent: "Sent",
      drafts: "Drafts", 
      someinvisible: "Nie wszystkie wiadomości pojawiają się na tej liście ze względu na ograniczenia zasad dostępu do informacji online."
    }
  }
};
</script>


<style>
.state {
  white-space: nowrap;
} 
.table-new, .table-new > td, .table-new > th {
	font-weight:  600;
}
.toolbar {
  padding: 0 0 30px 0;
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/Mail.vue